import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import 'styles/app/apps/slaMonitor/sla-monitor.scss'
import { connect } from 'react-redux'
import cn from 'classnames'
import Button from '@material-ui/core/Button'
import SiteLogHistory from 'components/Apps/SlaMonitor/SiteLogHistory'
import Environment from 'components/Apps/SlaMonitor/Environment'
import SidePopover from 'components/common/Popover/SidePopover'
import FilterBar from 'components/Apps/SlaMonitor/FilterBar'
import messages from 'components/Apps/SlaMonitor/translate'
import EnvironmentIcon from 'assets/img/apps/ic_pew.svg'
import { openCageDrawer } from 'reducers/slaMonitor/reducer'
import ActiveCageLoader from './ActiveCageLoader'
import SFRCorrected from './SFRCorrected'
import ActualVsExpected from './ActualVsExpected'
import DaysLeftFeeding from './DaysLeftFeeding'
import Sla from './Sla'

const MAX_WIDTH = 1279

class SlaMonitor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEnvironmentOpen: false,
      // eslint-disable-next-line react/no-unused-state
      hideCompassAndWeather: window.innerWidth > MAX_WIDTH,
    }
  }

  updateDimensions = () => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ hideCompassAndWeather: window.innerWidth > MAX_WIDTH })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  onCreateSLA = () => {
    const { activeCage, cageList } = this.props
    const cages = cageList.toArray()

    cages.map(cage =>
      cage.id === activeCage ? this.props.openCageDrawer(cage) : null,
    )
  }

  onEnvironmentClose = () => this.setState({ isEnvironmentOpen: false })

  onEnvironmentToggle = () =>
    this.setState(prevState => ({
      isEnvironmentOpen: !prevState.isEnvironmentOpen,
    }))

  render() {
    const {
      intl: { formatMessage },
      currentApp,
      activeSite,
    } = this.props
    const { isEnvironmentOpen } = this.state

    return (
      <div
        className={cn('module sla-module', {
          'environment-opened': isEnvironmentOpen,
        })}>
        <div className="module-head">
          <Typography className="module-title" variant="h5">
            {currentApp.name}
          </Typography>
          <div className="module-filter">
            <FilterBar />
            <Button
              className="createSla-button"
              color="primary"
              variant="contained"
              size="medium"
              onClick={this.onCreateSLA}>
              {formatMessage(messages.create)}
            </Button>
          </div>
        </div>
        {Boolean(activeSite) && (
          <div className="module-content">
            <Grid container spacing={2} className="widget-box">
              <ActiveCageLoader />

              <Sla />

              <ActualVsExpected />

              <SFRCorrected />

              <DaysLeftFeeding />

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SiteLogHistory />
              </Grid>
            </Grid>
          </div>
        )}
        <Button
          variant="contained"
          onClick={this.onEnvironmentToggle}
          className="env-button">
          <img
            src={EnvironmentIcon}
            alt={formatMessage(messages.environment)}
          />
        </Button>
        <SidePopover
          appBar
          open={isEnvironmentOpen}
          close={this.onEnvironmentClose}
          title={formatMessage(messages.environment)}
          backDrop={{ invisible: true }}>
          <Environment />
        </SidePopover>
      </div>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    cageList: state.getIn(['slaMonitor', 'cageList']),
    activeCage: state.getIn(['slaMonitor', 'activeCage']),
  }),
  {
    openCageDrawer,
  },
)(injectIntl(SlaMonitor))
